import { useContext, useEffect } from 'react';
import ConfigContext from '../../ConfigContext/ConfigContext.js';
const useExternalPaymentFetch = (onFetchPersonalizedPaymentDetails, zip, enableExernalFetchForVehicle, isNDSPenciled, updateIsLoading, udsLocalStateValues) => {
  const {
    activeTab,
    initialDealType,
    selectedCreditTier,
    obfuscatedCredit,
    selectedLeaseTerm,
    selectedLoanTerm,
    financeDownPayment,
    leaseDownPayment,
    financeDownPaymentPercentageValue,
    localTradeInValue,
    localAmountOwed,
    selectedMileage
  } = udsLocalStateValues || {};
  const {
    enableExternalPaymentFetch
  } = useContext(ConfigContext) ?? {};
  useEffect(() => {
    const pencilingData = {
      dealType: activeTab || initialDealType,
      downPayment: financeDownPayment,
      creditTier: obfuscatedCredit,
      leaseTerm: selectedLeaseTerm,
      loanTerm: selectedLoanTerm,
      tradeInValue: localTradeInValue,
      amountOwed: localAmountOwed,
      userZip: zip,
      mileage: selectedMileage,
      downPaymentPercent: financeDownPaymentPercentageValue
    };
    if (enableExternalPaymentFetch && onFetchPersonalizedPaymentDetails && (enableExernalFetchForVehicle || isNDSPenciled)) {
      updateIsLoading({
        isLoading: true
      }); // To handle syndication esntial payment loading state
      onFetchPersonalizedPaymentDetails(pencilingData);
    }

    /* eslint-disable react-hooks/exhaustive-deps */
  }, [selectedCreditTier, selectedLeaseTerm, selectedLoanTerm, financeDownPaymentPercentageValue !== null ? financeDownPaymentPercentageValue : financeDownPayment,
  // Finance Down payment has dependency with Down payment percentage
  financeDownPayment >= 0 ? null : leaseDownPayment,
  // Lease Down payment has dependency with Finance Down payment
  localTradeInValue, localAmountOwed, financeDownPayment >= 0 ? null : financeDownPaymentPercentageValue,
  // Down payment percentage has dependency with Finance Down payment
  enableExernalFetchForVehicle]);
};
export { useExternalPaymentFetch as default };
